import React from 'react';
import CompositeReportModule from '@lifeomic/phc-web-toolkit/src/components/SubjectViewer/Modules/CompositeReport';
import MemberDetail from './index';

type CompositeReportContentProps = {
  member: fhir.Patient | null;
  memberId: string;
  fallback: React.ReactNode;
};

export const CompositeReportContent: React.FC<CompositeReportContentProps> = ({
  member,
  memberId,
  fallback,
}) => {
  if (!member) {
    return <>{fallback}</>;
  }

  return (
    <CompositeReportModule
      patient={{
        ...member,
        id: member.id || memberId,
      }}
    />
  );
};

const MemberCompositeReport: React.FC = () => {
  return <MemberDetail section="composite-report" />;
};

MemberCompositeReport.displayName = 'MemberCompositeReport';
export default MemberCompositeReport;
